import { MessageCircle } from "lucide-react";
import { WHATSAPP_URL } from "@/lib/pdf";

export default function WhatsAppFloat() {
  return (
    <a
      href={WHATSAPP_URL}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with us on WhatsApp"
      className="wa-pulse fixed bottom-5 right-5 z-50 flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg transition-transform hover:scale-105 sm:bottom-6 sm:right-6"
      data-testid="whatsapp-fab"
    >
      <MessageCircle size={26} />
    </a>
  );
}
